// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { xProductDetailsPartNumberStyles } from "@keller/App/SharedStyle/ProductDetailsPartNumberStyles";
import { mergeWithCss } from "@keller/XDL/Utilities";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsUpcCodeStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const UpcCodeStyles: ProductDetailsUpcCodeStyles = {
    labelText: {
        ...mergeWithCss(xProductDetailsPartNumberStyles.labelText, {
            css: css`
                margin-right: 8px;
            `,
        }),
    },
    valueText: {
        ...mergeWithCss(xProductDetailsPartNumberStyles.valueText, {
            css: css`
                margin: 0 0 4px;
            `,
        }),
    },
};

const styles = UpcCodeStyles;

const ProductDetailsUpcCode: React.FC<Props> = ({ product }) => {

    if (product.isVariantParent) {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsUpcCode">
            <Typography {...styles.labelText}>{translate("UPC #")}</Typography>
            {product.detail?.upcCode}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsUpcCode),
    definition: {
        displayName: "UPC code",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
